import { render } from "./UseCasesDetailsOthers.vue?vue&type=template&id=05b4ae7c"
import script from "./UseCasesDetailsOthers.vue?vue&type=script&lang=js"
export * from "./UseCasesDetailsOthers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__